import FeeInfo from './fee-info.vue';

export default FeeInfo;
